/* Cart icon ride-in.
   On the first pageview of a session (per sessionStorage), clone the header
   cart icon, ride it in from off-screen left to its header spot, then swap
   the real icon back in. Skips entirely under prefers-reduced-motion. */
(function () {
  "use strict";

  var RIDE_MS = 2400; // travel time — slow enough to catch the eye
  var DELAY_MS = 700; // start after load settles so the visitor is looking

  try {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    if (sessionStorage.getItem("cc-cart-ride")) return;
  } catch (e) {
    return;
  }

  function run() {
    var link = document.getElementById("cart-icon-bubble");
    if (!link || !link.animate) return;
    var wrap = link.querySelector(".svg-wrapper");
    if (!wrap) return;

    var rect = wrap.getBoundingClientRect();
    // Bail if the icon isn't visible (collapsed header, scrolled past, etc.)
    if (!rect.width || rect.top < 0) return;

    try {
      sessionStorage.setItem("cc-cart-ride", "1");
    } catch (e) {
      /* private mode: animation just repeats per page */
    }

    var clone = wrap.cloneNode(true);
    clone.className = "cc-cart-ride";
    clone.setAttribute("aria-hidden", "true");
    clone.style.top = rect.top + "px";
    clone.style.width = rect.width + "px";
    clone.style.height = rect.height + "px";

    // The clone lives on <body>, outside the header's color context, so the
    // SVG would fall back to black. Carry the computed color over.
    var srcSvg = wrap.querySelector("svg");
    var cloneSvg = clone.querySelector("svg");
    if (srcSvg && cloneSvg) {
      var cs = window.getComputedStyle(srcSvg);
      cloneSvg.style.fill = cs.fill;
      cloneSvg.style.color = cs.color;
    }

    document.body.appendChild(clone);
    link.classList.add("cc-cart-ride-hide");

    var done = false;
    function settle() {
      if (done) return;
      done = true;
      // Re-query: cart sections can be re-rendered mid-ride by drawer updates.
      var liveLink = document.getElementById("cart-icon-bubble");
      if (liveLink) liveLink.classList.remove("cc-cart-ride-hide");
      link.classList.remove("cc-cart-ride-hide");
      clone.remove();
    }

    var anim = clone.animate(
      [
        { transform: "translateX(0)" },
        { transform: "translateX(" + (rect.left + 90) + "px)" }
      ],
      {
        duration: RIDE_MS,
        easing: "cubic-bezier(0.33, 0, 0.15, 1)", // rolls in fast, eases to a stop
        fill: "forwards"
      }
    );
    anim.onfinish = settle;
    window.setTimeout(settle, RIDE_MS + 1500); // safety net if onfinish never fires
  }

  function kick() {
    window.setTimeout(run, DELAY_MS);
  }

  if (document.readyState === "complete") {
    kick();
  } else {
    window.addEventListener("load", kick, { once: true });
  }
})();
